import {Injectable} from "@angular/core";
import {RequestOptionsArgs} from "@angular/http";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/do';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {JwtHelper} from "angular2-jwt";
import {AUTH_TOKEN_NAME, storage} from "../app.module";
import {MyHttp} from "./http";
import {environment} from "../config/environment";
import {User} from "../../pages/shared/user/user.model";
import {ProfileService} from "../../pages/profile/profile.service";

@Injectable()
export class AppAuth {
  private _user: any;
  public profile: User;
  private authObs$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  /**
   * Token payload
   */
  get user() {
    if (this._user === 'undefined') {
      this.setUser();
    }
    return this._user;
  }

  constructor(private jwtHelper: JwtHelper, private http: MyHttp, private profileService: ProfileService) {
    this.getAuthStatus().subscribe(loggedIn => this.onAuthStatusChanged(loggedIn));

    this.init();
  }

  init() {
    this.setUser();
  }

  getAuthStatus() {
    return this.authObs$;
  }

  isActivated() {
    return this.profile && this.profile.organisation_status === 'accepted';
  }

  updateAuthStatus(loggedIn) {
    this.authObs$.next(loggedIn);
  }

  login(user: any, opts?: RequestOptionsArgs) {
    return this.http.post( environment.API + '/auth/login', user, opts)
      .map(res => res.json())
      .do(res => {
        this.setToken(res.token).then(() => this.setUser());
      });
  }

  signup(user: any, role: string, opts?: RequestOptionsArgs) {
    return this.http.post(environment.API + '/auth/signup/' + role, user, opts)
      .map(res => res.json())
      .do(res => {
        this.setToken(res.token).then(() => this.setUser());
      });
  }

  logout() {
    return Observable.fromPromise(storage.remove(AUTH_TOKEN_NAME))
      .do(() => {
        this.setUser();
      })
  }

  setToken(token){
    return storage.set(AUTH_TOKEN_NAME, token);
  }

  getToken(){
    return storage.get(AUTH_TOKEN_NAME);
  }

  setUser(){
    return this.getPayload().then((payload) => {
      this._user = payload;
      this.updateAuthStatus(!!payload);
    });
  }

  getPayload(){
    return this.getToken()
      .then(token => token ? this.jwtHelper.decodeToken(token) : null);
  }

  private onAuthStatusChanged(loggedIn){
    // Update profile
    if(loggedIn){
      return this.profileService.getProfile()
        .subscribe(profile => {
          this.profile = profile
        });
    }
    this.profile = null;
  }
}




// WEBPACK FOOTER //
// ./src/app/core/auth.ts